export const PRODUCT_ID_VALIDATION_MAX_LENGTH = 12
export const productIdValidationValidSaeIdRegex = /^(?:[a-z]{0,2})(?:\d{5,})$/iu
export const productIdValidationValidMiraklIdRegex = /upm[a-z0-9]{6}/iu
export const productValidationExpExceptionsIdRegex = [/^d\d$/iu]
